import { DateTime } from 'luxon'
import { Grid_List } from '@app/post-lists/grid-list'

export interface Week_State {
    week: number;
    year: number;
    formatted_week: string;
    start: string|null
    start_of_week: DateTime;
    end: string|null
    end_of_week: DateTime;
    days: {
        mon: DateTime;
        tue: DateTime;
        wed: DateTime;
        thu: DateTime;
        fri: DateTime;
    };
}

export class Week_Filter {
    list: Grid_List
    current_week: Week_State|null = null
    container: HTMLElement|null = null

    constructor( list: Grid_List ) {
        this.list = list
        this.set_container()
        this.set_current_week()
        this.update_columns_headers()
    }

    set_current_week( date: DateTime | null = null ): void {
        const now = date ? date : DateTime.local()

        this.current_week = {
            week: now.weekNumber,
            year: now.weekYear,
            formatted_week: `${now.weekNumber}/${now.weekYear}`,
            start: now.startOf( 'week' ).toISODate(),
            start_of_week: now.startOf( 'week' ),
            end: now.endOf( 'week' ).toISODate(),
            end_of_week: now.endOf( 'week' ),
            days: {
                mon: now.startOf( 'week' ),
                tue: now.startOf( 'week' ).plus( { days: 1 } ),
                wed: now.startOf( 'week' ).plus( { days: 2 } ),
                thu: now.startOf( 'week' ).plus( { days: 3 } ),
                fri: now.startOf( 'week' ).plus( { days: 4 } ),
            }
        }

        console.log( 'current week', this.current_week )
    }

    get_current_week() {
        if ( ! this.current_week ) {
            throw new Error( 'no current week' );
        }

        return this.current_week
    }

    protected set_container() {
        const element: HTMLElement|null = document.querySelector( '.list-week-container' )

        if ( ! element ) {
            throw new Error( 'no container found' );
        }

        this.container = element
    }

    protected get_container() {
        if ( ! this.container ) {
            throw new Error( 'no container found' );
        }
        return this.container;
    }

    change_current_week( offset: number ) {
        console.log( 'current week', this.get_current_week().week )

        console.log( 'weeks in total', DateTime.fromObject( { 'year': this.get_current_week().year } ).weeksInWeekYear )

        const monday = DateTime.fromObject(
            {
                weekNumber: this.get_current_week().week,
                weekYear: this.get_current_week().year,
            }
        )

        if ( ! monday.isValid ) {
            return
        }

        const updated_monday = offset === 1 ? monday.plus( { weeks: 1 } ) : monday.minus( { weeks: 1 } )

        this.update_current_week( updated_monday )
    }

    enable_week_interactions() {
        const buttons = Array.from( this.get_container().querySelectorAll( 'button' ) )
        for ( const button of buttons ) {
            button.classList.remove( 'disabled' )
        }

        this.get_container().classList.remove( 'loading' )

        this.list.get_container().classList.remove( 'loading' )
    }

    disable_week_interactions() {
        const buttons = Array.from( this.get_container().querySelectorAll( 'button' ) )
        for ( const button of buttons ) {
            button.classList.add( 'disabled' )
        }

        this.get_container().classList.add( 'loading' )

        this.list.get_container().classList.add( 'loading' )
    }

    update_current_week( updated_monday: DateTime ) {
        console.log( 'next Week', updated_monday.toFormat( 'WW/kkkk' ) )

        this.set_current_week( updated_monday )

        this.get_container().dataset.week = updated_monday.toFormat( 'WW' )
        this.get_container().dataset.year = updated_monday.toFormat( 'kkkk' )

        const week_data: HTMLElement|null = this.get_container().querySelector( '.week .data' ) as HTMLElement
        week_data.innerHTML = updated_monday.toFormat( 'WW/kkkk' )

        const week_days: HTMLElement|null = this.get_container().querySelector( '.week-days' ) as HTMLElement
        week_days.innerHTML = `${updated_monday.toFormat( 'D' )} - ${updated_monday.plus( { days: 6 } ).toFormat( 'D' )}`

        this.update_columns_headers()
    }

    protected update_columns_headers() {
        this.update_column_header( 'week' )
        this.update_column_header( 'mon' )
        this.update_column_header( 'tue' )
        this.update_column_header( 'wed' )
        this.update_column_header( 'thu' )
        this.update_column_header( 'fri' )
    }

    protected update_column_header( day: string ) {
        const container = this.list.get_container().querySelector( `[data-column="${day}"]` )

        if ( ! container ) {
            return
        }

        const header = container.querySelector( '.column-header .date' ) as HTMLElement

        switch ( day ) {
            case 'week':
                header.innerHTML = `KW ${this.get_current_week().formatted_week}`
                break
            case 'mon':
                header.innerHTML = `${this.get_current_week().days.mon.toFormat( 'D' )}`
                break
            case 'tue':
                header.innerHTML = `${this.get_current_week().days.tue.toFormat( 'D' )}`
                break
            case 'wed':
                header.innerHTML = `${this.get_current_week().days.wed.toFormat( 'D' )}`
                break
            case 'thu':
                header.innerHTML = `${this.get_current_week().days.thu.toFormat( 'D' )}`
                break
            case 'fri':
                header.innerHTML = `${this.get_current_week().days.fri.toFormat( 'D' )}`
                break
        }

        return container
    }

    get_current_monday() {
        return this.get_current_week().days.mon
    }
}
